import mizaem_ru from './settings/mizaem_ru';
import mizaem_ua from './settings/mizaem_ua';
import mizaem_kz from './settings/mizaem_kz';
import mxcredito from './settings/mxcredito';
import zaimko from './settings/zaimko';
import zaimko_u_ru from './settings/zaimko_u_ru';
import zaimko_u_kz from './settings/zaimko_u_kz';
import zaimko_u_mx from './settings/zaimko_u_mx';
import vncredito from './settings/vncredito';


const companys = {
    mizaem_ru: mizaem_ru,
    mizaem_ua: mizaem_ua,
    mizaem_kz: mizaem_kz,
    mxcredito: mxcredito,
    zaimko: zaimko,
    zaimko_u_ru: zaimko_u_ru,
    zaimko_u_kz: zaimko_u_kz,
    zaimko_u_mx: zaimko_u_mx,
    vncredito: vncredito,
}
const company = process.env.VUE_APP_COMPANY

const settings = companys[company];

export default settings;
